module.exports = __webpack_public_path__ + "img/search.37630531.svg";